import { STATIC_HOST } from './variables';

export const formatter = new Intl.NumberFormat('es-AR');

export const shuffleArray = array => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * i)
        const temp = array[i]
        array[i] = array[j]
        array[j] = temp
    }
    return array;
}

export const proccessAdInfo = info => {
    let data = info["_source"];
    let commercialCondition = '';
    let isSponsored = false;
    let fPrice = data.precio.valor;
    if (data.descuento > 0) {
        fPrice = fPrice * (100 - data.descuento) / 100
    }
    if (data.patrocinado) {
        let now = new Date();
        let startDate = new Date(data.patrocinado.start_date + 'T00:00:00')
        let endDate = new Date(data.patrocinado.end_date + 'T00:00:00')
        if (!data.patrocinado.delete && data.patrocinado.can_be_activated && now > startDate && now < endDate) {
            commercialCondition = data.patrocinado.condition
            isSponsored = true
        }
    }

    if (!isSponsored && data.usuario.cuenta) {
        if (data.condiciones_comerciales_principal && (data.usuario.cuenta.features.account_type === 3 || data.usuario.cuenta.features.account_type === 4)) {
            commercialCondition = data.condiciones_comerciales_principal.detail;
        }
    }

    return {
        id: info["_id"],
        title: data.titulo,
        picture: data.pictures ? STATIC_HOST + data.pictures[0].variants[225].jpg : 'https://static.aastatic.com.ar/img/no-fotos-225x180.png',
        price: data.precio.valor,
        discount: data.descuento,
        finalPrice: formatter.format(fPrice),
        currency: data.precio.moneda_signo,
        year: data["año"],
        usage: data.horas_trabajo,
        location: data.ubicacion.provincia,
        nameInAds: data.name_in_ads,
        seller: data.usuario.apodo,
        sponsored: isSponsored,
        commercialCondition: commercialCondition
    }
}